import { Component, Input, TemplateRef, ViewChild, computed, signal } from '@angular/core';
import { OrderBaseComponent } from '../order-base.component';
import { FlowTypes } from '../../../common/models/order/order.model';
import { BusinessInformation } from '../../../common/models/order/workflow/service-info-collection.model';
import { OrderRoutePaths } from '../orders-routes.enum';
import { Sales_Help_Resources } from './sales-help-resources';
import { Popover } from 'primeng/popover';
import { OrderNavigationComponent } from '../order-navigation/order-navigation.component';

@Component({
  selector: 'app-order-menu',
  templateUrl: './order-menu.component.html',
  styleUrl: './order-menu.component.scss',
  standalone: false
})
export class OrderMenuComponent extends OrderBaseComponent {
  @ViewChild('cartContentTemplate') cartContentTemplate: TemplateRef<any>;
  @Input() customer: any;
  @Input() business: BusinessInformation;
  smbBusinessName = computed(() => {
    return this.order()?.serviceInfoCollection?.businessInformationSMB?.businessNameSMB ?? '';
  });
  isCartVisible = false;
  salesHelpVisible = signal(false);
  salesHelpSearch = signal('');
  @ViewChild('optools') optools: Popover;
  @ViewChild(OrderNavigationComponent) orderNavigationComponent?: OrderNavigationComponent;
  readonly salesHelpResources = Sales_Help_Resources;
  private readonly hideChangePackageRoutes = new Set([
    OrderRoutePaths.VIDEO_PACKAGE_SELECTION,
    OrderRoutePaths.BUNDLE_HOMEPAGE,
    OrderRoutePaths.ORDER_SUMMARY,
  ]);

  showChangePackageButton = computed(() => {
    const isExcludedRoute = [...this.hideChangePackageRoutes].some(route =>
      this.router.url.includes(route)
    );
    return this.currentFlow() === FlowTypes.VIDEO && this.isResidentialVideo() && !isExcludedRoute;
  });
  constructor() {
    super()
  }

  goToPackageSelection() {
    // navigate to video package selection
    this.navigate([this.orderRoutes.VIDEO_PACKAGE_SELECTION])
  }

  dispositionClicked() {

  }

  commentsClicked() {

  }

  filteredSalesHelpResources = computed(() => {
    const search = this.salesHelpSearch().trim().toLowerCase();
    if (!search) return this.salesHelpResources;
    return this.salesHelpResources
      .map(group => ({
        ...group,
        items: group.items.filter(item => item.title.toLowerCase().includes(search))
      }))
      .filter(group => group.items.length > 0);
  });

  salesHelpClicked() {
    this.optools?.hide();
    this.salesHelpSearch.set('');
    this.salesHelpVisible.set(true);
  }

  onSalesHelpSearch(value: string) {
    this.salesHelpSearch.set(value);
  }

  closeSalesHelp() {
    this.salesHelpVisible.set(false);
  }

  navigationClicked() {
    this.optools?.hide();
    this.orderNavigationComponent?.open();
  }

  toggleCart() {
    this.isCartVisible = !this.isCartVisible;
  }
}
